import type { LimitPlan } from '../../types';
import { getLimitPlanUpperLimit as getModernSubscriptionLimitPlanUpperLimit } from '../modernSubscription/getLimitPlanUpperLimit';

export function getLimitPlanUpperLimit(limitPlan: LimitPlan) {
  return getModernSubscriptionLimitPlanUpperLimit(limitPlan);
  // not supported for legacy subscriptions
}
